import './App.css';
import CreateTrans from "./Trans/CreateTrans";

function App() {
  return <CreateTrans/>;
}

export default App;
